export default __webpack_public_path__ + "b236fc2a928eb86aede7aaa5ebfc22ae.png";